import React from 'react';
import { SView, SImage, SNavigation, STheme, SText, SThread, SDate, SHr } from 'servisofts-component2';
import SSocket from 'servisofts-socket';
import SBLocation from 'servisofts-background-location';
// import CerrarSession from '../../Pages/Usuario/Page/Perfil/CerrarSession';
import PackageJson from "../../../package.json";
import NavBar from '.';
import MDL from '../../MDL';
import { ScrollView } from 'react-native';

import MInicio from "../../Assets/svg/mInicio.svg"
import MMAp from "../../Assets/svg/iconMap.svg"
import MSession from "../../Assets/svg/mSession.svg"
import Logo from "../../Assets/svg/registro/logo.svg"
import Verified_icon from '../../Assets/verified_icon.svg';


export default class body extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            load: false,
            time: new SDate().getTime()
        };
    }


    componentDidMount() {
        new SThread(100, "load-bar-data", true).start(() => {
            this.setState({ load: true })
        })
    }

    item({ url, label, icon, onPress, params }) {
        console.log(icon + " 999")
        return <SView col={"xs-11"} height={50} border={'transparent'} row onPress={() => {
            if (onPress) {
                onPress();
            }
            if (url) {
                SNavigation.navigate(url, params);
            }
            NavBar.close();
        }}  >
            <SView col={"xs-10"} height style={{ justifyContent: 'flex-start', }} row center>
                {icon}
                {/* <SIcon fill={STheme.color.text} name={icon} width={20} height={20} /> */}
                <SText font={"Montserrat-Medium"} style={{ paddingLeft: 5, color: STheme.color.text, fontSize: 14 }} >{label}</SText>
            </SView>
            <SView col={"xs-2"} height style={{ justifyContent: 'flex-end', }} row center>

            </SView>
        </SView>

    }

    render() {
        var usuario = MDL.usuario.session
        if (!usuario) {
            return <SView />
        }

        // var usuario = Model.usuario.Action.getUsuarioLog();
        // if (!usuario) return <SView col={"xs-12"} center height onPress={() => {
        //     SNavigation.navigate("/login")
        //     NavBar.close();
        // }}>
        //     <SText color={STheme.color.secondary} fontSize={18} center>{"Inicia sesión en tapeke."}</SText>
        // </SView>;
        // var usuario = {
        //     key: '52',
        //     Nombres: 'Usuario Prueba'
        // }
        return <>
            <SView col={"xs-12"} backgroundColor={STheme.color.primary} width="100%"
                style={{
                    borderBottomRightRadius: 21, borderBottomLeftRadius: 21, borderBottomWidth: 1, borderColor: STheme.color.card, alignItems: "center",
                    paddingTop: 16,
                    paddingBottom: 16,
                }} row>
                <SView col={"xs-3"} center style={{ textAlign: "right" }} height>
                    <SView style={{
                        width: 50,
                        height: 50, borderRadius: 30, overflow: "hidden", borderWidth: 1, borderColor: STheme.color.white,
                        backgroundColor: STheme.color.card
                    }}>
                        <SImage src={SSocket.api.root + "usuario/" + usuario?.key} style={{
                            width: "100%",
                            height: "100%",
                            resizeMode: "cover",
                            position: "absolute"
                        }} />
                        <SImage src={SSocket.api.root + "usuario/" + usuario?.key + "?date=" + new Date().getTime()} style={{
                            width: "100%",
                            height: "100%",
                            resizeMode: "cover"
                        }} />
                    </SView>
                </SView>
                <SView col={"xs-9"} onPress={() => {
                    // SNavigation.navigate('/profile');
                    NavBar.close();
                }}>
                    <SText font={"Montserrat-Bold"}
                        style={{
                            color: STheme.color.white,
                            fontSize: 16,
                        }} numberOfLines={1}>{usuario?.sNombreChofer}</SText>

                    <SView height={22} onPress={() => {
                        SNavigation.navigate('/perfil')
                        NavBar.close();
                    }} style={{
                        paddingLeft: 6,
                        alignItems: 'center',
                    }} row>
                        {/* TODO Revisar tema perfil */}
                        <SText fontSize={12} color={STheme.color.white} font='Montserrat-Medium' style={{
                            // textDecorationLine: 'underline',
                        }}>Ver perfil </SText>
                        {/* <SIcon name="Ver" width={9} color="#fff" /> */}
                    </SView>
                </SView>
            </SView>

            {/* <SScrollView2 disableHorizontal contentContainerStyle={{ width: "100%" }}> */}
            <ScrollView>
                {/* <SScroll> */}
                <SView height={20} border={'transparent'} />
                <SView col={"xs-12"} center  >
                    {this.item({ url: "/", label: "Inicio", icon: <MInicio fill={STheme.color.text} width={20} height={20} /> })}
                    {this.item({ url: "/permisos", label: "Permisos", icon: <MMAp fill={STheme.color.text} width={20} height={20} /> })}
                    {/* {this.item({ url: "/zona", label: "Zonas", icon: 'mZona' })} */}
                    {/* {this.item({ label: "Notificaciones", url: "/info/notificaciones", icon: 'mNotification' })} */}
                    {/* {this.item({ label: "Calificaciones", url: "/calificaciones", icon: 'mCalificaciones' })} */}
                    {/* {this.item({ url: "/ganancia", label: "Ganancias", icon: 'mGanancias' })} */}
                    {/* {this.item({ url: "/registro/doc_personal", label: "Documento usuario", icon: 'DocUsr', params: { edit: true } })} */}
                    {/* {this.item({ url: "/registro/info_vehiculo", label: "Documento vehículo", icon: 'DocDriver', params: { edit: true } })} */}
                    {/* {this.item({ url: "/driver_cuenta", label: "Cuentas bancarias", icon: 'Icuenta' })} */}
                    {/* {this.item({ url: "/info/terminos_y_condiciones", label: "Información legal", icon: 'mLegal' })} */}
                    {/* {this.item({ url: "/check/MessageInfo", label: "Checklist old", icon: <Verified_icon fill={STheme.color.text} width={18} height={18} /> })} */}
                    {this.item({ url: "/checklist", label: "Checklist", icon: <Verified_icon fill={STheme.color.text} width={18} height={18} /> })}

                    {this.item({
                        label: "Cerrar sesión", onPress: () => {
                            SBLocation.stop();
                            new SThread(100, "sadsad", true).start(() => {
                                MDL.usuario.logout().then(e => {
                                    SNavigation.reset("/login");
                                })

                                // Model.usuario.Action.unlogin();
                                // Model.usuario.Action.CLEAR();
                                // Model._events.CLEAR();
                                // NavBar.close();
                                // Validator.validate();/
                                // SNavigation.reset("/");
                            })

                        },
                        icon: <MSession fill={STheme.color.text} width={20} height={20} />,
                    })}

                    {/* <Verified_icon width={18} height={18} fill={STheme.color.danger} style={{ marginRight: 8 }} /> */}


                    <SHr height={40} />
                    <SView col={"xs-11"}>
                        <SHr height={2} color={STheme.color.text} />
                    </SView>
                    <SHr height={40} />

                    <SView col={"xs-9.5 md-5.8 xl-3.8"} center style={{ bottom: 0, }}>
                        <Logo name={"Logo"} style={{ width: "100%" }} fill={STheme.color.secondary} />
                    </SView>
                    <SHr height={30} />
                    <SView row >
                        {/* <SText style={{ paddingLeft: 5, paddingTop: 2, color: "#666666", fontSize: 18 }} font={"LondonMM"}>Version 1.4.0</SText> */}
                        <SText style={{ paddingLeft: 5, paddingTop: 2, color: "#909294", fontSize: 18 }} font={"LondonMM"}>Version {PackageJson.version}</SText>

                    </SView>
                    <SView height={20} border={'transparent'} />
                </SView>
            </ScrollView>
        </>
    }
}